import React from "react";

export default function Loader({ label = "Loading..." }) {
  return (
    <div style={{ padding: 16, textAlign: "center", opacity: 0.7 }}>
      {label}
    </div>
  );
}
